import { jsx } from 'react/jsx-runtime';
import { StyledActionButtonContainer } from 'baseui/snackbar';
import { Button } from '../button/button.js';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useStyletron } from '../../theme/utils.js';
import '../../theme/types.js';

const ActionButton = ({ children: actionButtonProps }) => {
  var _a;
  const [, theme] = useStyletron();
  const { children, onClick } = (_a = actionButtonProps == null ? void 0 : actionButtonProps.props) != null ? _a : {};
  return jsx(StyledActionButtonContainer, { "$style": { marginRight: theme.space[12] }, children: jsx(Button, { kind: "flat", onClick, "$style": {
    textDecoration: "underline",
    backgroundColor: "inherit",
    fontWeight: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    color: "inherit"
  }, children }) });
};

export { ActionButton };
